export default __webpack_public_path__ + "static/media/features-illustration-mac.c4e40741.png";